module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Time_Black.786756d6.svg";